import React, { useEffect, useState } from 'react'
import { Simulator } from '@ion-ui/simulator'
import CryptoJS from 'crypto-js'
import { View, useStyles } from '@ion-ui/core'
import quickSimulator from '../../lib/quickSimulator'
import analytics from '../../lib/analytics.js'
import chronosFetch from '../../lib/chronos'
import lookup from '../../lib/lookup'
import leadCreate from '../../lib/createLead'
import { dataLayerV2UniversalPush } from '../../utils/tagManager'
import { Styles } from './styles'


const Calculator = () => {
  const styles = useStyles(Styles)
  const [leadID, setLeadId] = useState(null)
  const [personType, setPersonType] = useState('')

  useEffect(() => {
    async function fetch() {
      if (window) {
        window.oAuth = await chronosFetch(process.env.GATSBY_CHRONO_AUTH_URL, 'POST', {
          grant_type: 'client_credentials',
          scope: 'leads/simulation-read leads/lead-create verification/verification-read verification/verification-create'
        })
      }
    }
    fetch()
  }, [])

  const getCookie = (name, cookie) => {
    const value = `; ${cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
  }

  const redirectOnbording = (user) => {
    const secret = process.env.GATSBY_GATEWAY_SECRET
    const data = {
      email: user.email,
      name: user.name,
      simulationId: user.simulationId,
      creditType: 'LIQUIDITY',
      phoneNumber: user.phoneNumber,
      leadId: leadID || user.leadId,
      redirectVerification: 'www.ion.com.mx',
      source: 'LP_MKT'
    }
    console.log(data)
    const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), secret).toString()
    setTimeout(
      () =>{
        window.open(process.env.GATSBY_ONBOARDING + '/#/password?lead=' + encodeURIComponent(ciphertext), '_self')
      }, 800
    )
  }

  return (
    <View css={styles.card}>
      <Simulator
        hubspotButtonsCallback={(typeTaggeo) => {
          analytics(typeTaggeo)
        }}
        noticeOfPrivacy={() => {
          if (typeof window !== 'undefined') {
            window?.open(`${process.env.GATSBY_WEBSITE}/aviso-privacidad/`)
          }
        }}
        createLeadCallback={async (user) => {
          const resultCookie = getCookie('hubspotutk', window?.document?.cookie)
          user.cookieHubspot = resultCookie
          const checkLookup = await lookup(user)
          if (!checkLookup?.user_exists) {
            const res = await leadCreate(user)
            dataLayerV2UniversalPush({
              'eventCategory': 'Lead_3',
              'eventAction': 'Form_Sent',
              'eventLabel': 'Lp_Mkt_Liquidez',
              'event': 'Lead_3_Event'
            })
            setLeadId(res.id)
            if (res.id) {
              if (personType === 'NATURAL') {
                user.leadId = res.id
                redirectOnbording(user)
                return false
              }
            }
            return true
          } else if (checkLookup.message === 'Email registrado') {
            return 'user_exists'
          } else if (checkLookup.message === 'Teléfono registrado') {
            return 'phone_exists'
          } else if (checkLookup.message === 'Email y teléfono registrado') {
            return 'both_exists'
          }
        }}
        callback={async (xTag, payload) => {
          delete payload.activity_years
          setPersonType(payload.person_type)
          const res = {}
          res.data = await quickSimulator(payload)
          return res
        }}
        variant='NATURAL'
        productName='LIQUIDITY'
        screenNumber={0}
        isMultisimulator={false}
        universalTag=''
        taggeoTag=''
        cardId='simulator'
      />
    </View>
  )
}

export default Calculator
